module.exports = __webpack_public_path__ + "img/footer-logo-1.e000c0a0.png";